export default __webpack_public_path__ + "static/media/Next.af9d938f.svg";